import React from "react";

import TextBlock from "../components/textBlock";

type fileBuildOnlyData = {
	file_build_only_quantity: string;
	file_build_only_var_recipient_email: string;
};

type FileBuildOnlyViewProps = {
	data: fileBuildOnlyData;
};

const FileBuildOnlyView = ({ data }: FileBuildOnlyViewProps) => {
	const { file_build_only_quantity, file_build_only_var_recipient_email } =
		data || {};
	return (
		<>
			<TextBlock
				label="Quantity"
				value={file_build_only_quantity}
				dataAutotest="quantity"
			/>
			<TextBlock
				label="VAR Recipient Email"
				value={file_build_only_var_recipient_email}
				dataAutotest="varRecipientEmail"
			/>
		</>
	);
};

export default FileBuildOnlyView;
